import { FC } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ROUTES from "@/data/Routes";

const Layout: FC = () => {
  const location = useLocation();

  const isDashboardRoute =
    location.pathname === ROUTES.DASHBOARD ||
    location.pathname === ROUTES.RESULTS ||
    location.pathname === ROUTES.CONNECTIVITY ||
    location.pathname === ROUTES.ACCOUNT;

  const showHeaderFooter = !isDashboardRoute;
  const headerTheme =
    location.pathname === ROUTES.HOME ? "transparent" : "light";

  return (
    <div className="flex min-h-screen flex-col">
      {showHeaderFooter && <Header theme={headerTheme} />}

      {/* container */}
      <main className="mx-auto w-full flex-grow">
        <Outlet />
      </main>
      {showHeaderFooter && <Footer />}
    </div>
  );
};

export default Layout;
